import { SearchStateService } from './search-state.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IHotelEntityCity } from '@core/models/hotel';

@Injectable()
export class HotelsResultsService {
  private options: any = { observe: 'response' };

  constructor(
    private http: HttpClient,
    private searchStateService: SearchStateService,
  ) {}

  /**
   * Gets the available hotels information asynchronously
   * @param {string} entityId
   * @param {string} query
   * @return {Observable}
   */
  public getHotels(entityId, query): Observable<any> {
    return this.http.get(`/hotels/async/${entityId}/hotels`, {
      ...this.options,
      params: query,
    });
  }

  /**
   * Gets the available offers hotels information asynchronously
   * @param {string} entityId
   * @param {String} query
   * @return {Observable}
   */
  public getHotelsOffers(entityId: string, query: string): Observable<any> {
    return this.http.get(`/hotels/async/${entityId}/offers${query}`, this.options);
  }

  /**
   * Gets the offers banner information asynchronously
   * @param {string} countryId
   * @param {String} cityId
   * @return {Observable}
   */
  public getBanner(countryId: string, cityId: string): Observable<any> {
    const query = {
      countryId: countryId,
      cityId: cityId,
    };
    return this.http.get(`/hotels/async/offers/banner`, {
      ...this.options,
      params: query,
    });
  }

  /**
   * Gets all hotels from the current state entity
   * @return {Observable}
   */
  public getAll(): Observable<any> {
    const id = this.searchStateService.getSlugId();
    const query = this.searchStateService.getQuery();
    return this.http.get(`/hotels/async/allresult/${id}`, {
      ...this.options,
      params: query,
    });
  }

  /**
   * Gets catalog entity from the current search
   * @return {Observable}
   */
  public getEntity(entityType: string, entityId: string): Observable<any> {
    return this.http.get(`/hotels/async/catalog/${entityType}/${entityId}`, this.options);
  }

  /**
   * Gets catalog entity Country Id from the current search
   * @return {Observable}
   */
  public getEntityCountryId(entityId: string): Observable<any> {
    return this.http.get(`/hotels/async/geo/relations/CITY/${entityId}/COUNTRY`);
  }

  /**
   * Get hotels cities entities
   * @param {string} hotelsIds
   * @return {Observable}
   */
  public getHotelsCitiesEntities(hotelsIds: string): Observable<any> {
    return this.http.get(`/hotels/async/geo/${hotelsIds}`, this.options);
  }

  public getEntityCity(entityId: string): Observable<IHotelEntityCity> {
    return this.http.get<IHotelEntityCity>(`/hotels/async/geo/city/${entityId}`);
  }

  /**
   * Submit event to p13n simple_landing_view
   * @param {string} entityId
   * @return {Observable}
   */
  public sendEventLandingP13n(entityId: string): Observable<any> {
    return this.http.post('/hotels/async/p13n/event/landing', {
      destinationId: entityId,
    });
  }

  /**
   * Get the phone number of almundo
   * @return {Observable}
   */
  public getPhoneNumber(): Observable<any> {
    return this.http.get(`/community/phone?source=${encodeURIComponent(location.href)}`);
  }

  /**
   * Gets hotels when filtered point of interest
   * @return {Observable}
   */
  public getHotelsPoi(poiID: any): Observable<any> {
    return this.http.get(`/hotels/async/geo/entities/${poiID}`);
  }

  /**
   * Gets distance from POIS to hotels
   * @param {string} poisId
   * @param {string} hotelsIds
   * @return {Observable}
   */
  public getPoisDistance(poisId: string, hotelsIds: string): Observable<any> {
    return this.http.get(`/hotels/async/geo/distance/${poisId}/${hotelsIds}`);
  }
}
